var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-h5 py-5 px-4 text-center"},[(_vm.query?.length > 0)?_c('span',[_vm._v(" Result: "+_vm._s(_vm.query)+" ")]):_vm._e()]),_c('book-view',{attrs:{"books":_vm.books,"pagination":_vm.pagination},on:{"update":({ order, nextPage }) => _vm.getBooks(nextPage, this.pageSize, order)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }